export enum ImageType {
  ALPR = 'lpr',
  LPCrop = 'lp',
  Context = 'context',
  PreContext = 'pre_context',
  PreContextRedDot = 'pre_context_red_dot',
}
